export default __webpack_public_path__ + "static/media/vol3_1.241531b8.png";